<div id="alert-status-count-widget">
  @for (status of statusCounts(); track status.name) {
    <div class="status-count-card box is-elevation-1" [style.background-color]="status.color">
      <span [class]="'text-color-' + status.textColorClass">{{ status.count }}&nbsp;{{ status.name }}</span>
    </div>
  }

  @let activeIncidentCount = state.activeIncidentCount();

  @if (!!activeIncidentCount && activeIncidentCount > 0) {
    <div class="status-count-card box is-elevation-1" [style.background-color]="'#EE6400'">
      <span class="'text-color-light">{{ activeIncidentCount }}&nbsp;{{ 'MANAGEMENT.MENU.INCIDENTS' | translate }}</span>
    </div>
  }
</div>
